import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getBaseUrl } from "../../Utils/Utils";

const fetchProducts = createAsyncThunk("products/fetch", async()=>{
    const url = getBaseUrl();
    const response = await axios.get(`${url}/products`);
    return response.data
})
export {fetchProducts}